"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_text_mask_1 = __importDefault(require("react-text-mask"));
var components_1 = require("../../styles/components");
var Input_styled_1 = require("../input/Input.styled");
function InputWithMask(_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, label = _a.label, disabled = _a.disabled, placeholder = _a.placeholder, className = _a.className, mask = _a.mask, required = _a.required;
    return (react_1.default.createElement(Input_styled_1.StyledInputWrapper, { className: className },
        label && (react_1.default.createElement(components_1.InputLabel, { htmlFor: name, required: required }, label)),
        react_1.default.createElement(react_text_mask_1.default, { type: "text", mask: mask, placeholderChar: '\u2000', "aria-label": !label && name, name: name, value: value, disabled: disabled, id: name, onChange: onChange, placeholder: placeholder, render: function (ref, props) { return react_1.default.createElement(Input_styled_1.StyledInput, __assign({ ref: ref }, props)); } })));
}
exports.default = InputWithMask;
//# sourceMappingURL=InputWithMask.js.map